import React, { useState } from 'react';
import perfilesTuberiaRectagularesEstructural from '../../databases/rectangularTubes';
import perfilesTuberiaCuadraraEstructural from '../../databases/rectangularTubes';

const SettingsMenu = ({
  xAxis,
  zAxis,
  setXAxis,
  setZAxis,
  floors, 
  spacingMatrix, 
  setSpacingMatrix,
  selectedSpacing,

  minimumColumnProfile,
  setMinimumColumnProfile
}) => {
  // Estado para el tipo de perfil seleccionado
  const [selectedProfileType, setSelectedProfileType] = useState('rectangular');
  
  // Bases de datos de perfiles organizadas por tipo
  const profileDatabases = {
    rectangular: perfilesTuberiaRectagularesEstructural,
    cuadrada: perfilesTuberiaCuadraraEstructural
  };

  // Tipos de perfiles disponibles
  const profileTypes = [
    { id: 'rectangular', name: 'Tubería Rectangular - Acero A36' },
    { id: 'cuadrada', name: 'Tubería Cuadrada - Acero A36' }
  ];

  const handleChange = (index, value) => {
    const updatedMatrix = [...spacingMatrix];
    const parsedValue = parseFloat(value);
    const min = 2;
    const max = 12;
  
    if (isNaN(parsedValue) || parsedValue < min || parsedValue > max) {
      alert(`Ingrese un valor entre ${min} y ${max} metros`);
      return;
    }
  
    updatedMatrix[index].spacing = parsedValue;
    setSpacingMatrix(updatedMatrix);
  };  

  // Maneja el cambio de tipo de perfil
  const handleProfileTypeChange = (e) => {
    const type = e.target.value;
    setSelectedProfileType(type);
    // Establece el primer perfil como selección por defecto al cambiar el tipo
    const firstProfileId = profileDatabases[type]?.[0]?.id || 23;
    setMinimumColumnProfile(firstProfileId);
  };

  // Maneja el cambio de perfil específico
  const handleProfileChange = (e) => {
    setMinimumColumnProfile(parseInt(e.target.value, 10));
  };

  // Valida y actualiza los ejes
  const handleAxisChange = (setter, value) => {
    const min = 2;
    const max = 10;
    
    if (isNaN(value) || value < min || value > max) {
      alert(`Ingrese un valor entre ${min} y ${max}`);
      return;
    }
    
    setter(value);
  };

  return (
    <div className="w-1/4 p-4 bg-gray-200 fixed right-0 top-0 h-full">
      <h2 className="text-2xl font-bold text-center mb-5 border-b-4 uppercase">
        Ajustes
      </h2>

      <h3 className="text-lg font-semibold">Geometría</h3>
      
      <div className="mt-4 flex space-x-4">
        <div>
          <label htmlFor="ejeX" className="block">Eje X</label>
          <input            
            type="number"
            value={xAxis}
            onChange={(e) => handleAxisChange(setXAxis, Number(e.target.value))}
            className="p-2 mt-1 border border-gray-400 rounded w-full"
            min="2"
            max="10"
          />
        </div>

        <div>
          <label htmlFor="ejeY" className="block">Eje Y</label>
          <input
            type="number"
            value={zAxis}
            onChange={(e) => handleAxisChange(setZAxis, Number(e.target.value))}
            className="p-2 mt-1 border border-gray-400 rounded w-full"
            min="2"
            max="10"
          />
        </div>
      </div>

      <div className="mb-2">
        <label htmlFor="storyNumber" className="block">Número de Pisos</label>
        <input 
          type="number" 
          value={floors} 
          disabled
          className="p-2 mt-1 border border-gray-400 rounded w-full"
          min="1" 
          max="3"
        />
      </div>

      {/* Dropdown para tipo de perfil */}
      <div className="mb-2">
        <label htmlFor="profileTypeSelect" className="block">Tipo de Perfil</label>
        <select
          id="profileTypeSelect"
          value={selectedProfileType}
          onChange={handleProfileTypeChange}
          className="p-2 mt-1 border border-gray-400 rounded w-full"
        >
          {profileTypes.map(type => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      {/* Dropdown para perfiles específicos */}
      <div className="mb-2">
        <label htmlFor="profileSelect" className="block">Seleccionar Perfil</label>
        <select
          id="profileSelect"
          value={minimumColumnProfile || 59}
          onChange={handleProfileChange}
          className="p-2 mt-1 border border-gray-400 rounded w-full"
        >
          {profileDatabases[selectedProfileType]?.map(profile => (
            <option key={profile.id} value={profile.id}>
              {profile.name}
            </option>
          ))}
        </select>
      </div>
    
      <div className="mb-2">
        <h2 className="block">Separaciones</h2>
        
        <div className="p-4 border rounded bg-white shadow-md">
          <h2 className="text-lg font-bold mb-2">Separaciones de Ejes</h2>
          <table className="border-collapse border border-gray-300 w-full text-center">
            <thead>
              <tr>
                <th className="border border-gray-300 p-2">Sección</th>
                <th className="border border-gray-300 p-2">Espaciado (m)</th>
              </tr>
            </thead>
            <tbody>
              {spacingMatrix.map((item, index) => (
                selectedSpacing === item.section && (
                  <tr key={item.section}>
                    <td className="border border-gray-300 p-2">{item.section}</td>
                    <td className="border border-gray-300 p-2">
                      <input
                        type="number"
                        step="0.05"
                        min="2"
                        max="12"
                        value={item.spacing}
                        onChange={(e) => handleChange(index, e.target.value)}
                        className="w-16 text-center border rounded"
                      />
                    </td>
                  </tr>
                )
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SettingsMenu;